// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:900px){.gift-card-hero .gift-card-hero-image{max-width:750px}.gift-card-hero .gift-card-hero-image img{width:100%}}.gift-card-hero h3{font-family:\"URW DIN Black\",sans-serif;color:#d65d27;text-shadow:1px 1px 0 #933a2a}@media(min-width:900px){.gift-card-hero h3{text-shadow:2px 2px 0 #933a2a;font-size:52px}}.gift-card-hero .gift-card-hero-button{background:#d65d27;font-family:\"URW DIN\",sans-serif}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
